import { Scroll, ScrollHandler } from '../libs/p-scroll.module.js'
import $ from 'zepto-modules'
import { Expo, TweenMax } from 'gsap'
import '../libs/froogaloop.js'

const Timeline = () => {
  let scroll = new Scroll()
  scroll.friction = 0.001

  window.scroll = scroll

  scroll.stop(0).toInterval({ offset: 10 }).on(/enter|exit/, event => {
    let svg = $('.section-logo text, .section-logo path, .section-logo polyline')
    let linkWeb = $('.linkWeb a')

    if (event.target.state === 1) {
      let black = '#000000'
      svg.forEach((v, i) => {
        $(v).attr('style', 'fill:' + black)
      })
      linkWeb.css({
        'border': `2px solid ${black}`,
        'color': black
      })
    } else {
      let white = '#ffffff'
      svg.forEach((v, i) => {
        $(v).attr('style', 'fill:' + white)
      })
      linkWeb.css({
        'border': `2px solid ${white}`,
        'color': white
      })
    }
  })

  const pageHeight = innerHeight

  scroll.stop(pageHeight)
  scroll.stop()

  scroll.interval({ min: 0, max: pageHeight }).on('update', event => {
    $('main').css({
      transform: `translateY(${-event.target.local * innerHeight}px)`
    })

    $('.section-header').css({
      'background-position-y': event.target.local * innerHeight + 'px'
    })
  })

  let handler = new ScrollHandler('body')

  // handler.on('wheel-increase-speed-y', event => {
  //   scroll.velocity = event.speed * 50
  // })

  // handler.on('wheel-max-speed-y wheel-stop', event => {
  //   // scroll.velocity = 0
  //   if (scroll.position < 0 || scroll.position > pageHeight)
  //     scroll.shoot()
  // })
  handler.on('swipe-up', event => scroll.toPreviousStop())
  handler.on('swipe-down', event => scroll.toNextStop())

  let dots = $('.dot')
  dots.forEach((v, i) => {
    let getHeight = $(v).attr('height')
    $(v).css('top', getHeight)
  })

  let lastPosition = 0
  let lastStop

  var iframe = $('.video-desktop iframe')[0]
  var videoPlayer = $f(iframe)

  dots.each((i, element) => {
    $('.content')[i].style.opacity = 0

    scroll.stop(pageHeight + lastPosition * 4)
      .toInterval({ offset: 150, tags: `bob+${i}` })
      .on('enter', event => {
        let tlHeight = dots[i].getAttribute('height')
        TweenMax.to($('.timeline'), 0.8, {
          'height': tlHeight,
          ease: Expo.easeOut
        })

        if (event.target.state_old === -1) {
          TweenMax.to(dots[i], 0.3, {
            delay: 0.4,
            opacity: 1
          })

          let dotSmall = $(dots[i]).find('dotSmall')
          TweenMax.to(dotSmall, 0.5, {
            delay: 0.4,
            scale: 1,
            ease: Expo.easeOut
          })

          TweenMax.to(dots[i], 0.5, {
            className: '-=dot-active'
          })
        }

        if (event.target.state_old === 1) {
          TweenMax.to(dots[i], 0.5, {
            delay: 0.4,
            opacity: 1,
            className: '-=dot-active'
          })
        }

        TweenMax.set($('.timeline-about'), {
          clip: 'rect(525px,728px,0px,0px)'
        })

        if (i === 0) {
          TweenMax.to($('.header-mask'), 0.5, {
            opacity: 1
          })
          TweenMax.to($('.section-header'), 0.3, {
            scale: 0.97
          })
        }

        if (i === 6) {
          TweenMax.to($('.timeline-about'), 1, {
            clip: 'rect(0px,525px,728px,0px)',
            ease: Expo.easeOut
          })
        }

        if (i > 5) {
          TweenMax.to($('player'), 0.3, {
            opacity: 0
          })
        }

        if (i === 7) {
          TweenMax.set($('player'), {
            opacity: 0,
            delay: 0.5
          })

          $('.section-content').addClass('section-video')

          TweenMax.fromTo($('.video-desktop'), 1, {
            clip: 'rect(0px,1280px,720px,0px)',
            opacity: 0
          }, {
            clip: 'rect(0px,1280px,720px,0px)',
            opacity: 1,
            ease: Expo.easeOut
          })

          TweenMax.set($('.section-content article'), {
            width: '50%'
          })
        }
        // display screen
        // $('.video-phone')[i].style.opacity = 1
        TweenMax.to($('.video-phone')[i], 0.5, {
          opacity: 1
        })
      })
      .on('leave', event => {
        if (i === 0) {
          TweenMax.to($('.header-mask'), 0.5, {
            opacity: 0
          })
          TweenMax.to($('.section-header'), 0.5, {
            scale: 1
          })
        }

        if (i === 7) {
          TweenMax.to($('.section-content div span'), 0.5, {
            opacity: 1
          })
          $('.section-content').removeClass('section-video')
          videoPlayer.api('pause')
          TweenMax.set($('.section-content article'), {
            clearProps: 'width'
          })
        }

        if (i === 6) {
          TweenMax.to($('player'), 0.3, {
            delay: 0.2,
            opacity: 1
          })
        }

        TweenMax.to(dots[i], 0.5, {
          className: '-=dot-active'
        })

        if (event.target.state === 1) {
          TweenMax.to(dots[i], 0.5, {
            className: '+=dot-active'
          })
        }

        if (event.target.state === -1) {
          TweenMax.to(dots[i], 0.5, {
            opacity: 0
          })
          TweenMax.to(dots[i], 0.5, {
            className: '-=dot-active'
          })
        }

        TweenMax.to($('.video-phone')[i], 0.5, {
          opacity: 0
        })
      })

    let stop = scroll.stop(pageHeight + lastPosition * 4)

    stop
      .toInterval({ offset: 150 })
      .on('update', event => {
        let a = event.target.local * 2

        if (a > 1) a = 2 - a

        let b = event.target.local * 2 - 1

        $('.content')[i].style.opacity = a
        $('.content')[i].style.transform = `translateY(${-50 * b}px)`
      })

    if (lastStop) {
      scroll.interval({ min: lastStop.position, max: stop.position })
      // .on('enter', event => console.log(time[i - 1], time[i]))
        .on('update', event => {
          let min0 = time[i - 1]
          let min1 = time[i]
          let min = mix(min0, min1, event.target.local)

          setTime(min)
        })
    }

    lastStop = stop

    if (i === 0) stop.on('update', event => null)

    lastPosition = element.offsetTop

    let time = [
      21,
      22,
      23,
      25,
      26,
      41,
      49,
      49
    ]

    // Times
    const coef = (n, min, max, clamp = true) => (clamp && n < min) ? 0 : (clamp && n > max) ? 1 : (n - min) / (max - min)
    const mix = (a, b, ratio) => a + (b - a) * ratio

    setTime(time[0])

    function setTime (time) {
      let dy = 56 + 10

      let d0 = time % 10
      let d1 = Math.floor(time / 10) % 10 + coef(time % 10, 10 - 1, 10)

      let digits = document.querySelectorAll('.time-change .wrapper')

      let values = [d1, d0]

      digits.forEach((digit, i) => {
        let y = -dy * values[i]
        digit.style.transform = `translateY(${y}px)`
      })
    }
  })

  // let scrollBSVG = new ScrollSVG({ scroll: scroll, scale: .25, color: '#333' })
  // scrollBSVG.svg.style.setProperty('position', 'fixed')
  // scrollBSVG.svg.style.setProperty('top', '50px')
  // scrollBSVG.svg.style.setProperty('z-index', 'pageHeight')
  // document.body.appendChild(scrollBSVG.svg)
}

export default Timeline



// WEBPACK FOOTER //
// ./src/components/timeline.js